import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Thankyou from "../assets/images/thank-you.png";
import { Link } from "react-router-dom";

const ThankyouPage = () => {
  return (
    <section className="section-padding">
      <Container>
        <Row>
          <Col lg="12" className="text-center">
            <div className="thankyou-card">
              <div className="image">
                <img src={Thankyou} alt="" />
              </div>
              <h2>Thank You for Requesting a Consultation!</h2>
              <p>
                Thank you for reaching out! Your request for a free consultation
                has been successfully submitted. Our team will review your
                details and get in touch with you shortly to discuss your home
                service needs.
              </p>
              <div className="greeting mb-5">Have a great day! 😊</div>
              <Link className="btn orange-btn" to={"/"}>
                Go to home
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ThankyouPage;
